import { render, staticRenderFns } from "./SelectLand.vue?vue&type=template&id=6a5bf288"
import script from "./SelectLand.vue?vue&type=script&lang=js"
export * from "./SelectLand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports